import { useContext } from 'react';
import { CreatedContextDispatch } from './ContextLanguage';

export const DispatchLanguage = () => useContext(CreatedContextDispatch)
